module.exports = __webpack_public_path__ + "img/29.53227425.jpg";